import React, { useContext, useEffect, useState } from 'react';
import { Button, Input, Modal, Search, Select } from '@scuf/common';
import descriptors from '../../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';
import { useUtilityAccountContext } from '../../../context/UtilityAccountContext/UtilityAccountContext';
import UtilityAccountAction from '../../../context/UtilityAccountContext/UtilityAccountActions';
import './EnableIDSModalBodyTheme.scss';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { connectorConfigCheck } from '../../UtilityServiceModal/ConnectTab/ConnectTabUtils';
import useConnectorAndDynamicProps from '../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import { IResult } from '@scuf/common/dist/components/Search/ISearchProps';
import { ApiContext } from '../../../context/ApiContext';
import {
  convertUtilityProvidersToOptions,
  debounce
} from '../../shared/Utils/Utils';
import { isLoadingCheck } from '../../shared/Utils/UtilityViewDetails';
import { getNotifyForEnableIDS } from '../../shared/Utils/UtilitySettings/UtilitySettingsUtils';

const UtilityTypeOptions = [
  {
    text: 'Electricity',
    value: 'Electricity'
  },
  {
    text: 'Gas',
    value: 'Gas'
  }
];
const EnableIDSModal = (props: any) => {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const [state, dispatch] = useUtilityAccountContext();
  const emaasContext = useContext(ApiContext);
  const { showEnableIDSModal, selectedUtility } = state;

  let { bearerToken, requestContext, parentPutAxios } = props;
  const [SearchKeyword, setSearchKeyword] = useState('');
  const [resultSelectedFromSearch, setResultSelectedFromSearch] = useState<
    boolean
  >(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [provCheckLoader, isProvCheckLoader] = useState<boolean>(false);
  const [providerError, setProviderError] = useState(false);
  const [providerId, setProviderId] = useState<string>('');
  const [selectedUtilityProvider, SetSelectedUtilityProvider] = useState<IAny>({
    utilityProviderName: ''
  });
  const [providerName, setProviderName] = useState<string>('');
  const [results, setResults] = useState<IResult[]>([]);
  const [userInputs, setUserInputs] = useState({
    userName: '',
    password: ''
  });
  const [submitLoading, setSubmitLoading] = useState(false);

  const connectorConfigForSearch: IAny = {
    name: connectorConfigCheck(SearchKeyword, 1),
    options: {
      includeHbsmProviders: 'false'
    }
  };

  const requestContextForSearch = {
    ...requestContext,
    context: {
      ...requestContext.context,
      searchKeyword: SearchKeyword
    }
  };

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig: connectorConfigForSearch,
    requestContext: requestContextForSearch,
    bearerToken
  });

  const connectorConfigProviderCheck: IAny = {
    name: 'manual-to-automatic-service-provider'
  };

  const requestContextForProviderCheck = {
    ...requestContext,
    context: {
      ...requestContext.context,
      providerId: state.selectedUtility.providerId
    }
  };

  const dataConnectorProviderCheck: IAny = useConnectorAndDynamicProps({
    connectorConfig: connectorConfigProviderCheck,
    requestContext: requestContextForProviderCheck,
    bearerToken
  });

  useEffect(() => {
    if (showEnableIDSModal) {
      setResultSelectedFromSearch(true);
      setIsLoading(true);
      isProvCheckLoader(true);
      dataConnectorProviderCheck &&
        dataConnectorProviderCheck[0].actions &&
        dataConnectorProviderCheck[0].actions.getAll();
    } else {
      setResultSelectedFromSearch(false);
    }
  }, [showEnableIDSModal]);

  let IsProvExists =
    dataConnectorProviderCheck &&
    dataConnectorProviderCheck.length &&
    dataConnectorProviderCheck[0].data &&
    (dataConnectorProviderCheck[0].data.all as unknown);

  let isDataAvailableForProvCheck: IAny = '';
  if (IsProvExists && typeof IsProvExists === 'boolean') {
    isDataAvailableForProvCheck = true;
  } else if (!IsProvExists && typeof IsProvExists === 'boolean') {
    isDataAvailableForProvCheck = false;
  }

  useEffect(() => {
    SetSelectedUtilityProvider({
      utilityProviderName: state.selectedUtility.providerName
    });
  }, [state.selectedUtility]);

  useEffect(() => {
    if (IsProvExists && typeof IsProvExists === 'boolean') {
      isProvCheckLoader(false);
      setIsLoading(false);
      setProviderId(state.selectedUtility.providerId);
      setProviderName(state.selectedUtility.providerName);
    } else if (!IsProvExists && typeof IsProvExists === 'boolean') {
      isProvCheckLoader(false);
      setProviderError(true);
    }
  }, [IsProvExists, isDataAvailableForProvCheck]);

  useEffect(() => {
    setResults([]);
    dataConnector && dataConnector.actions && dataConnector.actions.getAll();
  }, [SearchKeyword]);

  const apiContext = useContext(ApiContext);
  const { notifyMessage } = apiContext;

  const SearchProvider = async (value: string) => {
    setSearchKeyword(value.trim());
  };

  const { all, loading, error, status } = dataConnector.data;
  const UtilityProviderResponse: IAny = (all as unknown) as IAny;
  let isDataAvailable: boolean;
  if (UtilityProviderResponse) isDataAvailable = true;
  else isDataAvailable = false;

  const debounceTimeLimit = 500;
  const debouncedSearch = debounce(SearchProvider, debounceTimeLimit);

  useEffect(() => {
    setIsLoading(loading);
    if ((isDataAvailable || error || status) && !loading) {
      if (isDataAvailable) {
        let UtilityProviders = convertUtilityProvidersToOptions(
          UtilityProviderResponse?.data
        );
        let searchresults = UtilityProviders.map((provider) => {
          return {
            title: provider.text,
            value: provider.value
          };
        });
        let filteredResults = searchresults.filter((searchEle) => {
          return searchEle.title
            .toLowerCase()
            .includes(SearchKeyword.toLowerCase());
        });
        setResults(filteredResults);
      }
    }
  }, [isDataAvailable, loading]);

  useEffect(() => {
    if (!showEnableIDSModal) {
      setUserInputs({
        userName: '',
        password: ''
      });
    }
  }, [showEnableIDSModal]);

  const handleChange = (value: string, name: string) => {
    setUserInputs({ ...userInputs, [name]: value });
  };

  const serviceTypeId: { [key: string]: string } = {
    Electricity: '2FFEE473-07FB-436E-AFCC-0B13464B1B7E',
    Gas: '344F9FD4-B18B-4B4A-A654-D9D9015A1CC3',
    Water: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B',
    Sewer: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
  };

  const hadleSubmit = async () => {
    let reqPayload = {
      serviceProviderId: selectedUtility.providerId,
      serviceProviderName: selectedUtility.providerName,
      siteId: emaasContext.siteId,
      utilityAccountId: selectedUtility.utilityAccountId,
      credential: btoa(`${userInputs.userName}:${userInputs.password}`),
      accountDetails: [
        {
          accountNumber: selectedUtility.accountNumber,
          serviceTypeId: serviceTypeId[selectedUtility.utilityType],
          serviceTypeName: selectedUtility.utilityType,
          idsEnabled: true
        }
      ],
      isCredentailsUpdated: false
    };
    setSubmitLoading(true);
    const response = await parentPutAxios('enroll', reqPayload);
    setSubmitLoading(false);
    closeModal();
    const { notifyDescription, notifyType } = getNotifyForEnableIDS(response);
    notifyMessage && notifyMessage(t(notifyDescription), notifyType);
  };

  const closeModal = () => {
    dispatch(UtilityAccountAction.hideEnableIDSModal());
  };

  return (
    <Modal
      className="emaas-enableIDS-modal"
      size="large"
      closeIcon={true}
      onClose={closeModal}
      open={showEnableIDSModal}
      closeOnDimmerClick={false}
    >
      <Modal.Header className="enableIDS-header">
        {t(d.EnableIDSHeaderTxt)}
      </Modal.Header>
      <Modal.Content className="enableIDS-content">
        <span className="enableIDS-info">{t(d.EnableIDSText)}</span>
        <div className="IDSenable-Search-provider">
          <div className="IDSutility-provider-label IDS-text">
            {t(d.UTILITYPROVIDERLABEL)}*
          </div>
          <Search
            placeholder={t(d.SEARCHPROVIDER)}
            noResultsMessage={isLoadingCheck(isLoading, t)}
            results={results}
            value={selectedUtilityProvider.utilityProviderName}
            disabled={true}
            required={true}
            onResultClear={() => {
              setProviderError(true);
            }}
            onSearchChange={(value) => {
              setResultSelectedFromSearch(false);
              debouncedSearch(value);
            }}
            onMouseOut={() => {
              if (!UtilityProviderResponse.data || !resultSelectedFromSearch) {
                setProviderError(true);
              }
            }}
            onResultSelect={(value) => {
              setResultSelectedFromSearch(true);
              setProviderError(false);
              SetSelectedUtilityProvider(JSON.parse(value.value));
              setProviderId(JSON.parse(value.value).utilityProviderId);
              setProviderName(JSON.parse(value.value).utilityProviderName);
            }}
          />
          {providerError && (
            <span className="total-error">{t(d.UTILITYPROVIDERERROR)}</span>
          )}
        </div>
        <div className="IDS-account-details">
          <Input
            placeholder="Enter Account Number"
            label={t(d.ACCNUMBER)}
            required={true}
            value={selectedUtility.accountNumber}
            disabled={true}
            className="IDS-text enableIDS-accountNumber"
          />
          <Select
            placeholder="Input"
            className="IDS-text enableIDS-utilityType"
            label={t(d.UtilityTypeforselectutility)}
            required={true}
            value={selectedUtility.utilityType}
            disabled={true}
            options={UtilityTypeOptions}
          />
        </div>
        <div className="enableIDS-userName">
          <Input
            placeholder="Enter Username"
            className="IDS-text"
            name="userName"
            label={t(d.USERNAME)}
            required={true}
            value={userInputs.userName}
            onChange={(value) => handleChange(value, 'userName')}
          />
        </div>
        <div className="enableIDS-password">
          <Input
            placeholder="Enter Password"
            className="IDS-text"
            label={t(d.PASSWORD)}
            required={true}
            value={userInputs.password}
            type="password"
            name="password"
            disablePasswordToggle={true}
            onChange={(value) => handleChange(value, 'password')}
          />
        </div>
      </Modal.Content>
      <Modal.Footer className="enableIDS-footer">
        <Button
          type="secondary"
          content={t(d.CANCEL)}
          onClick={closeModal}
        ></Button>
        <Button
          type="primary"
          content={t(d.SUBMIT)}
          loading={submitLoading}
          disabled={
            providerError || !userInputs.userName || !userInputs.password
          }
          onClick={() => hadleSubmit()}
        ></Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EnableIDSModal;
